





















import Vue from "vue";
import { mapGetters } from "vuex";
export default Vue.extend({
  props: {
    activites: {
      default: [],
    },
    intitule: {
      default: "intitule",
    },
  },
  methods: {
    trim(str: string) {
      return str.replace(/\s/g, "_");
    },
    icon(intitule: string) {
      let ICON: any = {};
      ICON[
        "ICON_1"
      ] = require(`@/assets/activite/icons-types/ALSH_SEJOUR_AUTOMNE.svg`);
      ICON[
        "ICON_2"
      ] = require(`@/assets/activite/icons-types/ALSH_SEJOUR_NOEL.svg`);
      ICON[
        "ICON_3"
      ] = require(`@/assets/activite/icons-types/ALSH_SEJOUR_HIVER.svg`);
      ICON[
        "ICON_4"
      ] = require(`@/assets/activite/icons-types/ALSH_SEJOUR_PRINTEMPS.svg`);
      ICON[
        "ICON_5"
      ] = require(`@/assets/activite/icons-types/ALSH_SEJOUR_ETE.svg`);
      ICON[
        "ICON_6"
      ] = require(`@/assets/activite/icons-types/ALSH_SEJOUR_MERCREDI.svg`);
      ICON["ICON_7"] = require(`@/assets/activite/icons-types/ATELIERS.svg`);
      ICON[
        "ICON_8"
      ] = require(`@/assets/activite/icons-types/PERISCOLAIRE.svg`);
      ICON[
        "ICON_9"
      ] = require(`@/assets/activite/icons-types/RESTAURATION.svg`);
      ICON[
        "ICON_DEFAULT"
      ] = require(`@/assets/activite/icons-types/default.png`);

      switch (intitule) {
        case "AL Toussaint":
          return ICON["ICON_1"];
        case "AL Noël":
          return ICON["ICON_2"];
        case "AL Hiver":
          return ICON["ICON_3"];
        case "AL Printemps":
          return ICON["ICON_4"];
        case "AL Eté":
          return ICON["ICON_5"];
        case "AL Mercredi / Samedi":
          return ICON["ICON_6"];
        case "Atelier":
          return ICON["ICON_7"];
        case "Stage":
          return ICON["ICON_7"];
        case "Périscolaire":
          return ICON["ICON_8"];
        case "Restauration":
          return ICON["ICON_9"];
        case "SJ Toussaint":
          return ICON["ICON_1"];
        case "SJ Noël":
          return ICON["ICON_2"];
        case "SJ Hiver":
          return ICON["ICON_3"];
        case "SJ Printemps":
          return ICON["ICON_4"];
        case "SJ Eté":
          return ICON["ICON_5"];
        case "Séjour Toussaint":
          return ICON["ICON_1"];
        case "Séjour Noël":
          return ICON["ICON_2"];
        case "Séjour Hiver":
          return ICON["ICON_3"];
        case "Séjour Printemps":
          return ICON["ICON_4"];
        case "Séjour Eté":
          return ICON["ICON_5"];
        case "SJ Mercredi / Samedi":
          return ICON["ICON_6"];
        default:
          return ICON["ICON_DEFAULT"];
      }
    },
  },
  computed: {
    ...mapGetters("activites", ["getIsDateDiff"]),
  },
});
